"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IcyImpactors = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const ResourceType_1 = require("../../ResourceType");
const Tags_1 = require("../Tags");
const SelectOption_1 = require("../../inputs/SelectOption");
const OrOptions_1 = require("../../inputs/OrOptions");
const constants_1 = require("../../constants");
const LogHelper_1 = require("../../LogHelper");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
const CardRenderer_1 = require("../render/CardRenderer");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const Units_1 = require("../../Units");
const PlaceOceanTile_1 = require("../../deferredActions/PlaceOceanTile");
class IcyImpactors extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.ICY_IMPACTORS,
            tags: [Tags_1.Tags.SPACE],
            cost: 15,
            resourceType: ResourceType_1.ResourceType.ASTEROID,
            metadata: {
                cardNumber: 'X47',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action(undefined, (eb) => {
                        eb.megacredits(10).titanium(1).brackets.startAction.asteroids(2);
                    }).br;
                    b.action('Spend 10 M€ (titanium may be used) to add 2 asteroids here, or spend 1 asteroid here to place an ocean tile. FIRST PLAYER CHOOSES WHERE YOU MUST PLACE IT.', (eb) => {
                        eb.or().asteroids(1).startAction.oceans(1).asterix();
                    });
                }),
            },
        });
        this.resourceCount = 0;
    }
    play() {
        return undefined;
    }
    canAct(player) {
        const canSpendResource = this.resourceCount > 0;
        const canPayForAsteroids = player.canAfford(10, { titanium: true });
        const oceansMaxed = player.game.noOceansAvailable();
        const trGain = oceansMaxed ? 0 : 1;
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        if (this.resourceCount >= 1)
            Card_1.Card.setRedsActionWarningText(player, trGain, this, redsAreRuling, 'place an ocean');
        if (oceansMaxed) {
            Card_1.Card.setUselessActionWarningText(this, 'oceans are already maxed');
        }
        if (canPayForAsteroids)
            return true;
        if (!canSpendResource)
            return false;
        if (canSpendResource && oceansMaxed)
            return true;
        if (redsAreRuling) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails();
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        return true;
    }
    action(player) {
        const opts = [];
        const addResources = new SelectOption_1.SelectOption('Pay 10 M€ to add 2 asteroids here', 'Pay', () => {
            this.addResources(player);
            return undefined;
        });
        const spendResource = new SelectOption_1.SelectOption('Remove 1 asteroid: First player chooses where you place an ocean', 'Remove asteroid', () => {
            this.spendResource(player);
            return undefined;
        });
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        const oceansMaxed = player.game.noOceansAvailable();
        if (this.howToAffordReds !== undefined)
            player.howToAffordReds = this.howToAffordReds;
        if (this.resourceCount > 0) {
            if (!redsAreRuling || oceansMaxed || (redsAreRuling && player.canAfford(this.reserveUnits.megacredits))) {
                opts.push(spendResource);
            }
        }
        else {
            return this.addResources(player);
        }
        if (player.canAfford(10, { titanium: true })) {
            opts.push(addResources);
        }
        else {
            return this.spendResource(player);
        }
        return new OrOptions_1.OrOptions(...opts);
    }
    addResources(player) {
        player.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 10, { canUseTitanium: true, title: 'Select how to pay for Icy Impactors action' }));
        player.addResourceTo(this, { qty: 2, log: true });
        return undefined;
    }
    spendResource(player) {
        this.resourceCount--;
        LogHelper_1.LogHelper.logRemoveResource(player, this, 1, 'place an ocean');
        const firstPlayer = this.getFirstEligiblePlayer(player.game);
        player.game.defer(new PlaceOceanTile_1.PlaceOceanTile(firstPlayer, 'Select space for ocean tile', player));
        return undefined;
    }
    getFirstEligiblePlayer(game) {
        let firstPlayer = undefined;
        for (const player of game.getPlayers()) {
            if (player.hasConceded === false) {
                firstPlayer = player;
            }
            if (firstPlayer !== undefined)
                break;
        }
        return firstPlayer;
    }
    getActionDetails() {
        return new RedsPolicy_1.ActionDetails({ oceansToPlace: 1 });
    }
}
exports.IcyImpactors = IcyImpactors;
//# sourceMappingURL=IcyImpactors.js.map